import { IconProps } from "../../utils/global-types/global-types";

const CircularArrowBackIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g clipPath="url(#clip0_2002_32819)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M9 17.333A8.333 8.333 0 1 1 9 .667a8.333 8.333 0 0 1 0 16.666M5.077 9.59a.833.833 0 0 1 0-1.178l3.334-3.334a.833.833 0 0 1 1.178 1.179l-1.91 1.91h4.654a.833.833 0 1 1 0 1.667H7.68l1.91 1.911a.833.833 0 0 1-1.178 1.179z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2002_32819">
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default CircularArrowBackIcon;
